import { CreateStepArgs } from '@/lib/Steppers/CreateStepper/types';
import { CampaignIcon, DataSourcesIcon } from '@/lib';
import { EmailCampaignStep } from './EmailCampaignValidation';

export type EmailCampaignMode = 'create' | 'edit';

export const EMAIL_CAMPAIGN_STEPS = [
  {
    id: 'TitleDescription',
    title: 'campaign:emailWorkspace.steps.title',
    icon: CampaignIcon,
    isCompleted: false,
  },
  {
    id: 'AudienceSelection',
    title: 'campaign:emailWorkspace.steps.audienceSelection',
    icon: DataSourcesIcon,
    isCompleted: false,
  },
  {
    id: 'TemplateSelection',
    title: 'campaign:emailWorkspace.steps.templateSelection',
    icon: DataSourcesIcon,
    isCompleted: false,
  },
  {
    id: 'PreviewSchedule',
    title: 'campaign:emailWorkspace.steps.previewAndSend',
    icon: CampaignIcon,
    isCompleted: false,
  },
] as unknown as ReadonlyArray<CreateStepArgs<EmailCampaignStep> & { icon: typeof CampaignIcon; isCompleted: boolean }>;

export const EMAIL_CAMPAIGN_EDIT_STEPS = EMAIL_CAMPAIGN_STEPS.filter((step) => step.id !== 'TemplateSelection') as ReadonlyArray<
  CreateStepArgs<EmailCampaignStep> & { icon: typeof CampaignIcon; isCompleted: boolean }
>;

export const getEmailCampaignSteps = (mode: EmailCampaignMode) => (mode === 'edit' ? EMAIL_CAMPAIGN_EDIT_STEPS : EMAIL_CAMPAIGN_STEPS);
